// utils/normalizeAlbum.js

export function normalizeAlbum (apiData) {
  return {
    // Keep original fields that components expect
    albumid: apiData.albumid || apiData.id || null,
    album: apiData.album || apiData.title || '(Untitled Album)',
    picture: apiData.picture || '',
    albumyear: apiData.albumyear || apiData.year || '',
    label: apiData.label || '',
    catalog: apiData.catalog || '',
    albumrating: apiData.albumrating || apiData.rating || '',
    // Also keep normalized versions for flexibility
    id: apiData.albumid || apiData.id || null,
    title: apiData.album || apiData.title || '(Untitled Album)',
    year: apiData.albumyear || apiData.year || '',
    rating: apiData.albumrating || apiData.rating || ''
  }
}

export function normalizeAlbumList (objOrArray) {
  if (!objOrArray) return []

  if (Array.isArray(objOrArray)) {
    return objOrArray.map(a => normalizeAlbum(a))
  }

  return Object.values(objOrArray).map(a => normalizeAlbum(a))
}
